<template>
	<div class="container">
		<div class="extractcar">
			<div class="extracimg">
				<img src="../../../assets/icon/Extract.png" alt="" width="100%" />
			</div>
			<div class="root" style="overflow: hidden">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item, i) in productVirtualList" :key="i">
							<img :src="defaultImg" width="100%" />
							<span class="prise">￥{{ item.salePriceWithTax }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="btn">
				<van-field class="recharge-vanfield btn" readonly clickable label="立即购买" @click="submit()" v-model="rdioName" />

				<div class="rechargevanpop">
					<van-popup class="recharge-vanpop" closeable :close-icon="icons" v-model="showPicker" round position="bottom">
						<div class="restitle">确认订单</div>

						<div class="tran">
							<span>充值项</span>
							<span>{{ productInfo.salePriceWithTax }}元</span>
						</div>
						<div class="xian"></div>
						<div class="tran">
							<span>优惠券</span>
							<span>暂无可用 ></span>
						</div>
						<div class="xian"></div>
						<div class="rechbtn" @click="submitOrder()">提交订单</div>
					</van-popup>
				</div>
			</div>
			<div class="xian"></div>
			<div class="rechargetext" v-if="productInfo && productInfo.content">
				<div v-html="productInfo.content"></div>
			</div>
			<div class="rechargetext" v-if="!productInfo || !productInfo.content">
				<div class="retitle">购买须知：</div>
				<div class="retext">
					<p>1.您承诺所购商品系个人合理自用且不进行二次销售。</p>
					<p>2.您知晓在东洋E购网站上购买的境外商品等同于境外购买。</p>
					<p>
						3.您知晓境外商品适用的品质、健康、安全、卫生、环保、标识等项目标准与中国大陆地区质量安全标准有所不同，在使用过程中由此可能产生的危害或损失以及其他风险，将由您个人承担。
					</p>
					<p>
						4.您知晓商品的订购人（即支付人）将被记录为进口方，必须遵守中国的法律法规。
					</p>
					<p>
						5.您知晓由于您所购买的境外商品从中国大陆（不含港澳台）以外的地区发出，故可能无中文标签及说明书。
					</p>
					<p>
						6.您同意委托商家选定适合的物流商，并将您所购买的商品运输至您指定的中国大陆境内的收货地点。
					</p>
				</div>
			</div>
			<div class="xian"></div>
			<div class="recommend">
				<div class="recomtitle">更多推荐</div>
				<!--推荐商品-->
				<van-swipe class="my-swipe" :autoplay="3000">
					<van-swipe-item v-for="(item, index) in productArray" :key="index">
						<productItem :productList="item" @click="detail"></productItem>
					</van-swipe-item>
				</van-swipe>
			</div>
			<bottom></bottom>
		</div>
	</div>
</template>

<script>
	import Swiper from "swiper";
	import "swiper/css/swiper.min.css";
	import productItem from "@/components/product/productItem.vue";
	import bottom from "@/components/bottom.vue";
	import wx from "weixin-js-sdk";
	import utils from "@/utils/utils";
	import {
		getRecommendedProductList,
		queryGoodsByType,
		directSettle,
		tradeSettleOrder,
	} from "@/api/api";
	export default {
		components: {
			productItem,
			bottom,
		},
		data() {
			return {
				value: "",
				fileList: [],
				radio: "0",
				showPicker: false,
				icons: require("../../../assets/icon/Popup.png"),
				rdioName: "",
				pictures: [],
				productArray: [],
				productVirtualList: [],
				defaultImg: require("../../../assets/icon/card.png"),
				swiperCurrentIndex: 0,
				productInfo: {}, // 当前选中商品
			};
		},
		methods: {
			onConfirm(value) {
				this.value = value;
				this.showPicker = false;
			},
			showPopup() {
				this.show = true;
			},
			detail() {},
			// 获取精选商品数据
			async getProduct() {
				const params = {};
				const res = await getRecommendedProductList(params);
				if (res.code === "0000") {
					if (res.data.length > 4) {
						for (let i = 0; i < res.data.length; i += 4) {
							this.productArray.push(res.data.slice(i, i + 4));
						}
					} else {
						this.productArray = res.data;
					}
				} else {
					this.$toast(res.msg);
				}
			},
			// 获取虚拟商品列表
			async queryGoodsByType() {
				const params = {
					type: 11,
				};
				let this_ = this;
				const res = await queryGoodsByType(params);
				if (res.code == "0000") {
					if (res.data && res.data.length > 0) {
						this_.productVirtualList = res.data;
						this_.productInfo = this_.productVirtualList[0];
						this_.$nextTick(() => {
							new Swiper(".swiper-container", {
								loopedSlides: 10,
								onTouchMove: function(swiper) {
									//你的事件
									this_.swiperCurrentIndex = swiper.activeIndex;
									if (
										this_.swiperCurrentIndex <= this_.productVirtualList.length
									) {
										this_.productInfo =
											this_.productVirtualList[this_.swiperCurrentIndex];
									} else {
										this_.productInfo =
											this_.productVirtualList[this_.swiperCurrentIndex + 1];
									}
								},
							});
						});
					}
				} else {
					this.$toast(res.msg);
				}
			},
			// 点击购买
			submit() {
				if (!this.productInfo) {
					this.$toast("请选择充值金额");
					return;
				}
				if (!utils.checkLogin()) {
					wx.miniProgram.navigateTo({
						url: "/pages/login/login",
					});
					return;
				}
				this.showPicker = true;
			},
			// 提交订单
			async submitOrder() {
				var this_ = this,
					param = {
						goodsId: this.productInfo.id,
						goodsNum: 1,
						saleUnitPrice: this.productInfo.salePriceWithTax,
					};
				const res = await directSettle(param);
				if (res.code == "0000" && res.data) {
					this_.tradeSettleOrder(res.data);
				}
			},
			async tradeSettleOrder(data) {
				let sendData = {
					settleNum: data.settleNum,
					shoppingCartId: data.shoppingCartId,
					productType: 11
				};
				const settle = await tradeSettleOrder(sendData);
				if (settle.code == "0000") {
					wx.miniProgram.navigateTo({
						url: "/pages/cashier/cashier?amount=" +
							data.buyTotalAmount +
							"&orderNo=" +
							settle.data,
					});
				}
			},
		},
		mounted() {
			this.getProduct();
			this.queryGoodsByType();
		},
	};
</script>

<style scoped lang="scss">
	.container {
		.extractcar {
			background-color: #fff;

			.extracimg {
				width: 690px;
				height: 245px;
				margin: 0 auto;
				padding-top: 30px;
			}

			.root {
				padding-top: 30px;

				.prise {
					padding-top: 20px;
					font-size: 30px;
					font-family: PingFangSC, PingFangSC-Regular;
					font-weight: 400;
					color: $theme-color-main;
					display: block;
					text-align: center;
				}
			}

			.btn {
				width: 590px;
				height: 78px;
				
				margin: 0 auto;
				margin-top: 44px;
				margin-bottom: 80px;
				background: $theme-color-main;
				border-radius: 38px;

				span {
					display: block;
					font-size: 28px;
					font-family: PingFangSC, PingFangSC-Regular;
					font-weight: 400;
					color: #333333;
					line-height: 28px;
				}

				.recharge-vanpop {
					height: 920px;
					border-radius: 20px 20px 0 0;

					.restitle {
						font-size: 30px;
						font-family: PingFangSC, PingFangSC-Medium;
						font-weight: 500;
						text-align: center;
						color: #333333;
						line-height: 30px;
						padding-top: 33px;
						padding-bottom: 23px;
					}

					.xian {
						width: 100%;
						margin-left: 30px;
						border: 1px solid #dedede;
					}

					.tran {
						padding-top: 35px;
						padding-bottom: 37px;
						padding-left: 30px;
						padding-right: 40px;
						display: flex;
						justify-content: space-between;
					}

					.rechbtn {
						font-size: 28px;
						font-weight: 400;
						text-align: center;
						color: #ffffff;
						letter-spacing: 1px;
						width: 710px;
						height: 78px;
						line-height: 78px;
						background: #1e53a4;
						border-radius: 38px;
						position: fixed;
						bottom: 31px;
						left: 50%;
						transform: translate(-50%, 0);
					}
				}
			}

			.xian {
				width: 100%;
				// margin-left: 30px;
				border: 1px solid #ededed;
			}

			.rechargetext {
				.retitle {
					font-size: 36px;
					font-weight: 500;
					color: #333333;
					letter-spacing: 1px;
					padding: 39px 19px 0 19px;
				}

				.retext {
					padding-top: 20px;
					padding-left: 29px;
					padding-right: 31px;
					padding-bottom: 40px;
					font-size: 26px;
					font-weight: 400;
					color: #666666;
					line-height: 36px;
					letter-spacing: 1px;
				}
			}

			.recommend {
				background-color: #fff;
				margin-bottom: 60px;

				.recomtitle {
					padding: 56px 20px 50px 20px;
					font-size: 36px;
					font-weight: 500;
					text-align: left;
					color: #333333;
					line-height: 36px;
				}
			}
		}

		.swiper-wrapper {
			display: flex;
			align-items: center;
		}

		.swiper-container {
			overflow: visible !important;
			width: 420px;
			// height: 280px;
			margin: 0 auto;
		}

		.swiper-container .swiper-wrapper .swiper-slide {
			width: 270px;
			border-radius: 20px;
			margin: 0 auto;
		}

		.swiper-container .swiper-wrapper .swiper-slide img {
			border-radius: 20px;
		}

		.swiper-container .swiper-wrapper .swiper-slide-prev {
			margin-right: 60px;
			margin-left: 70px;
			width: 270px !important;
			height: 176px !important;
		}

		.swiper-container .swiper-wrapper .swiper-slide-prev img {
			height: 176px !important;
		}

		.swiper-container .swiper-wrapper .swiper-slide-next {
			margin-right: 60px;
			margin-left: 70px;
			width: 270px !important;
			height: 176px !important;
		}

		.swiper-container .swiper-wrapper .swiper-slide-next img {
			height: 176px !important;
		}

		.swiper-container .swiper-wrapper .swiper-slide-active {
			width: 270px;
			margin-left: 10px;
		}
	}
	/deep/.van-cell{
		line-height: inherit;
	}
</style>
